module.exports = __webpack_public_path__ + "static/card-grants-committee-2024-12bc491f527239414bb6a0d09f8c4fd1.jpg";